import React, { Component } from 'react';
// import { Parallax } from 'react-skrollr'
import bgImage from  './assets/top_1.jpg';
import styles from  './styles.js';
// import scrollToElement from 'scroll-to-element';

class Top extends Component {
	render() {

		let elmStyl = Object.assign({}, styles.container, {
			backgroundImage: `url(${bgImage})`,
			backgroundSize: 'cover'
		});

		let st = {
			navigation: {
				position:'fixed',
				top: 0,
				right:0,
				zIndex: 10,
			},
			navigation_ul: {listStyleType:'none'},
			navigation_li: {
				display: 'inline-block',
				margin: '0 10px 10px 0',
				border: '1px solid #fff',
				backgroundColor: 'rgba(75, 94, 97, .3)',
				padding: '0 6px',
				cursor: 'pointer',

			},
			h3 : {
				position: 'absolute',
				left: '20px',
				bottom: '20px',
			},
			hvemEr1: {
				position: 'absolute',
				top: '30%',
				left: '10%',
			},
			hvemEr2: {
				position: 'absolute',
				top: '40%',
				left: '40%',
			},
			hvemEr3: {
				position: 'absolute',
				top: '50%',
				left: '70%',
			}
		}

		const click = function(e){
			let cl = '.' + e.target.getAttribute('data-link')
			var element = document.querySelector(cl)
			var posY = element.offsetTop;
			window.skr.animateTo(posY)
		}
		
		return (
			<div style={elmStyl} className='top'>
				<div style={styles.flex}>
					<div data-top="margin-top: 0px" data-center="margin-top: 140px"
						>
						<h1 style={styles.h1} >Byg Et Digt</h1>
					</div>
					<div
						data-top="opacity: 0" data-center="opacity: 1"
						>
						<p style={st.hvemEr1} >Kultur event</p>
					</div>
					<div
						data-top="opacity: 0"
						data-center="opacity: 1"
						>
						<p style={st.hvemEr2} >Undervisning</p>
					</div>
					<div
						data-top="opacity: 0"
						data-center="opacity: 1"
						>
						<p style={st.hvemEr3} >Rum for Fællesskab</p>
					</div>

					<h3 style={st.h3} >Digt udgivelser på Bogforum 2017</h3>

						
						
						


					<nav style={st.navigation}>
						<ul style={st.navigation_ul}>
							<li style={st.navigation_li} onClick={click} data-link='top'>Top</li>
							<li style={st.navigation_li} onClick={click} data-link='kulturEvent'>Kultur Event</li>
							<li style={st.navigation_li} onClick={click} data-link='undervisning'>Undervisning</li>
							<li style={st.navigation_li} onClick={click} data-link='community'>Fællesskab</li>
							<li style={st.navigation_li} onClick={click} data-link='quotes'>De syntes</li>
							<li style={st.navigation_li} onClick={click} data-link='contact'>Kontakt</li>
						</ul>
					</nav>
				</div>
			</div>

		)
	}
}

export default Top;



// WEBPACK FOOTER //
// ./src/components/Top.js